import {useRef, useEffect} from 'react';

/**
 * Helper para evitar diversas requisições desnecessárias
 * @author Renan Salustiano <renansalustiano2020@gmail.com>
 * @param _function
 * @param delay
 */
const useDebounce = (_function, delay) => {

    if(typeof  _function != 'function'){
        return;
    }

    const timeoutRef = useRef(null);

    /**
     * Cancela timeout caso o componente seja desmontado
     */
    useEffect(() => () => clearTimeout(timeoutRef.current), []);

    const debouncedFunction = (...args) => {
        clearDebounce();
        timeoutRef.current = setTimeout(() => {
            _function(...args)
        }, delay)
    }

    const clearDebounce = () => {
        clearTimeout(timeoutRef.current);
    }

    return [debouncedFunction, clearDebounce]
}

export default useDebounce;
